import FsLightbox from "fslightbox-react";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Carousel } from "../../common/components/Carousel";
import { productPageItemType } from "../../common/types";
import { ProductItem } from "./ProductItem";

export function ProductSlider({ description, slides }) {
	const [toggler, setToggler] = useState(false);
	const [zoomSlideImage, setZoomSlideImage] = useState(slides[0].visual.url);

	const handleZoomButtonClick = (image) => {
		setToggler(!toggler);
		setZoomSlideImage(image);
	};

	const productSlides = slides.map((slide, index) => {
		const { title, description, descriptionBottom, list, visual } = slide;

		return (
			<ProductItem
				key={index}
				description={description}
				descriptionBottom={descriptionBottom}
				title={title}
				list={list}
				visual={visual}
				onZoomButtonClick={handleZoomButtonClick}
			/>
		);
	});

	return (
		<section className="section--product-slider">
			<div className="container">
				<h2 className="section-title">Extensive Search Options</h2>
				{description && (
					<p className="section-description">{description}</p>
				)}
				<Carousel
					options={{
						slidesToShow: 1,
					}}
					slides={productSlides}
				/>
				<FsLightbox toggler={toggler} sources={[zoomSlideImage]} />
			</div>
		</section>
	);
}

ProductSlider.propTypes = {
	description: PropTypes.string,
	slides: PropTypes.arrayOf(productPageItemType).isRequired,
};
